import React from "react";

import { IEnumParamTypeDescriptor } from '../../database/interfaces/paramScript/IParamTypeDescriptor';
import EnumSelectorInput from "../../common/inputs/EnumSelectorInput";
import { localizedOptions } from "./enumOptions";
import i18n from "../../i18n";

/**
 * Enum property card content component.
 */
interface IEnumCardContentProps {
    typeDescriptor: IEnumParamTypeDescriptor;
    paramValue: string;
    property: string;
    onUpdateParamValue: (value: string) => void;
}

const EnumCardContent: React.FC<IEnumCardContentProps> = ({ typeDescriptor, paramValue, property, onUpdateParamValue }) => {
    return typeDescriptor && (
        <EnumSelectorInput
            label={i18n.t(`elements:enumLabel.${property}`, { defaultValue: typeDescriptor.label })}
            value={paramValue ? paramValue : (typeDescriptor.default as string || "")}
            options={localizedOptions(property, typeDescriptor.options || {})}
            tooltip={typeDescriptor.tooltip}
            editable={typeDescriptor.editable ?? false}
            readOnly={typeDescriptor.readOnly ?? false}
            onValueChange={onUpdateParamValue}
        />
    );
}

export default EnumCardContent;
